<script lang="ts">
    import { getContext } from 'svelte'
    import { derived as sderived } from 'svelte/store'

    import type { GenOrder } from '../order'

    import { gettext as _, resolve, tgettext } from 'hydria/services/gettext'
    import type { TGettext } from 'hydria/services/gettext'

    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'
    import ObAddCustom from './Add/Custom.svelte'
    import ObAddDomain from './Add/Domain.svelte'
    import ObAddRenew from './Add/Renew.svelte'
    import ObAddTransfer from './Add/Transfer.svelte'
    import ObAddWhois from './Add/Whois.svelte'
    import ObAddZone from './Add/Zone.svelte'

    // const orderId = getContext('orderId') as Readable<string>
    const Order = getContext('Order') as GenOrder
    const status = sderived(Order.status, ($status) => $status)
    // let order = sderived(Order.orderStore, ($order) => $order)

    type TabTag = 'domain' | 'whois' | 'renew' | 'transfer' | 'zone' | 'custom'
    interface Tab {
        id: TabTag
        text: TGettext
        component: any
    }
    const tabs: Tab[] = [
        {
            id: 'domain',
            text: tgettext('Domain'),
            component: ObAddDomain,
        },
        {
            id: 'whois',
            text: tgettext('Whois'),
            component: ObAddWhois,
        },
        {
            id: 'renew',
            text: tgettext('Renew'),
            component: ObAddRenew,
        },
        {
            id: 'transfer',
            text: tgettext('Transfert'),
            component: ObAddTransfer,
        },
        {
            id: 'zone',
            text: tgettext('Zone'),
            component: ObAddZone,
        },
        {
            id: 'custom',
            text: tgettext('Custom'),
            component: ObAddCustom,
        },
    ]
    let current: Tab = $state(tabs[0])
</script>

<style>
    .nav-link {
        text-decoration: none;
    }
</style>

<div class="card">
    <div class="tabs">
        <ul class="nav nav-tabs text-bg-light">
            {#each tabs as tab}
                <li class="nav-item">
                    <a
                        href="/"
                        class="nav-link"
                        class:active={current.id == tab.id}
                        onclick={(e) => {
                            e.preventDefault()
                            current = tab
                        }}>{$resolve(tab.text)}</a
                    >
                </li>
            {/each}
        </ul>
        <div class="tab-content p-3">
            {#if $status == 'loading'}
                <LoadingPattern pattern={['x', 'x']} />
            {:else}
                <current.component />
            {/if}
        </div>
    </div>
</div>
